<h1 class="no-margin no-padding" mat-dialog-title>{{title}}</h1>
<div mat-dialog-content [innerHtml]="message">
  <!-- {{message}} -->
</div>
<div mat-dialog-actions align="center">
  <button mat-flat-button color="accent" (click)="dismiss(true)" cdkFocusInitial>{{confirmBtnText}}</button>
  <button mat-stroked-button color="accent" (click)="dismiss()">Cancel</button>
</div>